var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.5 1C5.256 1 1 5.256 1 10.5S5.256 20 10.5 20s9.5-4.256 9.5-9.5S15.744 1 10.5 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8 8.5 2.5 2.5L15 6"
  })));
};
export { SvgClock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEwLjUgMUM1LjI1NiAxIDEgNS4yNTYgMSAxMC41QzEgMTUuNzQ0IDUuMjU2IDIwIDEwLjUgMjBDMTUuNzQ0IDIwIDIwIDE1Ljc0NCAyMCAxMC41QzIwIDUuMjU2IDE1Ljc0NCAxIDEwLjUgMVoiCiAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIgLz4KICA8cGF0aCBkPSJNOCA4LjVMMTAuNSAxMUwxNSA2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";